import { closeModal, useUi } from '../store/ui';
import {
  CreateChannelModal,
  CreateThreadModal,
  ChannelSettingsModal,
  InviteModal,
} from './modals/ChannelModals';
import { GuildSettingsModal } from './modals/GuildSettings';
import { CreatePollModal } from './modals/CreatePoll';
import { EventsModal } from './modals/Events';
import { UserSettingsModal } from './modals/UserSettings';
import { CreateGuildModal, ProfileModal, SafetyModal } from './modals/Misc';

export function Modals() {
  const modal = useUi((s) => s.modal);
  if (!modal) return null;
  switch (modal.kind) {
    case 'createGuild':
      return <CreateGuildModal onClose={closeModal} />;
    case 'invite':
      return <InviteModal channelId={modal.channelId} onClose={closeModal} />;
    case 'guildSettings':
      return <GuildSettingsModal guildId={modal.guildId} onClose={closeModal} />;
    case 'channelSettings':
      return <ChannelSettingsModal channelId={modal.channelId} onClose={closeModal} />;
    case 'createChannel':
      return (
        <CreateChannelModal
          guildId={modal.guildId}
          parentId={modal.parentId}
          type={modal.type}
          onClose={closeModal}
        />
      );
    case 'createThread':
      return (
        <CreateThreadModal
          guildId={modal.guildId}
          channelId={modal.channelId}
          messageId={modal.messageId}
          name={modal.name}
          onClose={closeModal}
        />
      );
    case 'events':
      return <EventsModal guildId={modal.guildId} onClose={closeModal} />;
    case 'createPoll':
      return <CreatePollModal channelId={modal.channelId} onClose={closeModal} />;
    case 'userSettings':
      return <UserSettingsModal onClose={closeModal} />;
    case 'profile':
      return <ProfileModal userId={modal.userId} guildId={modal.guildId} onClose={closeModal} />;
    case 'safety':
      return <SafetyModal channelId={modal.channelId} onClose={closeModal} />;
  }
}
